import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { t } from "@/i18n";

const ConfirmDialog = ({ open, onOpenChange, title, body, onConfirm, confirmLabel = t.common.delete, destructive = true }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="confirm-dialog" className="border-[#303030] bg-[#1b1b1b] text-[#f4f1ec]">
      <DialogHeader>
        <DialogTitle className="font-display">{title}</DialogTitle>
        {body && <DialogDescription className="text-[#a3a3a3]">{body}</DialogDescription>}
      </DialogHeader>
      <div className="mt-4 flex flex-col-reverse gap-2.5 sm:flex-row sm:justify-end sm:gap-2">
        <button className="v-btn-ghost min-h-[44px] sm:min-h-[36px] justify-center text-sm font-medium w-full sm:w-auto" data-testid="confirm-dialog-cancel" onClick={() => onOpenChange(false)}>{t.common.cancel}</button>
        <button
          className={`min-h-[44px] sm:min-h-[36px] justify-center inline-flex items-center rounded-lg px-4 text-sm font-semibold w-full sm:w-auto ${destructive ? "bg-[#e5655a] text-white hover:bg-[#ef7468]" : "bg-[#f5b544] text-[#1a1206]"}`}
          data-testid="confirm-dialog-confirm"
          onClick={() => { onConfirm(); onOpenChange(false); }}
        >
          {confirmLabel}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ConfirmDialog;
